<template>
  <div v-if="noSpantext">
    <v-btn
      :class="classB"
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
      :disabled="disabled"
    >
      <v-icon
        v-if="iconI"
        :left="!label"
        >{{ iconI }}</v-icon
      >
      <span
        v-if="!label"
        class="font-weight-bold"
      >
        <slot name="name"> NAME </slot>
      </span>
    </v-btn>
  </div>
  <div v-else>
    <v-tooltip
      v-if="!menu"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :class="classB"
          v-bind="{ ...attrs, ...$attrs }"
          v-on="{ ...on, ...$listeners }"
          :disabled="disabled"
        >
          <v-icon
            v-if="iconI"
            :left="!label"
            >{{ iconI }}</v-icon
          >
          <div v-if="!label">
            <slot name="name"> NAME </slot>
          </div>
        </v-btn>
      </template>
      <span>{{ spantext }}</span>
    </v-tooltip>

    <v-menu
      v-else
      bottom
      offset-y
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
            <v-btn
              class="text-caption font-weight-bold"
              v-bind="{ ...attrsMenu, ...attrsTooltip, ...$attrs }"
              v-on="{ ...onMenu, ...onTooltip, ...$listeners }"
              :disabled="disabled"
            >
              <v-icon left>{{ iconI }}</v-icon>
              <slot name="name"> NAME </slot>
            </v-btn>
          </template>
          <span>{{ spantext }}</span>
        </v-tooltip>
      </template>
      <slot name="list"> LIST </slot>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "AvsButton",
  props: {
    classB: {
      type: String,
      default: "text-caption font-weight-bold"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconI: {
      type: String
    },
    label: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    noSpantext: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    }
  }
}
</script>
